<template>
  <v-dialog max-width="450px" overlay-opacity="0.9" persistent :value="opened">
    <v-card>
      <v-card-text>
        <v-btn
          class="mb-10"
          icon
          style="position: absolute; right: 10px; top: 10px;"
          @click="$emit('close')"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-text>

      <v-card-text
        class="subtitle-2"
        style="font-size: 1rem !important; margin-top: 30px; text-align: center"
      >
        FontuMi combate el COVID-19 apoyando a otros micro-empresarios como
        nosotros que luchan por sobrevivir a través de las ventas digitales
      </v-card-text>

      <v-card-text class="pb-0">
        <lottie-player
          class="mt-3"
          src="https://assets10.lottiefiles.com/packages/lf20_wv4mTG.json"
          background="transparent"
          speed="1"
          style="width: 100%; height: 300px;"
          loop
          autoplay
        ></lottie-player>
      </v-card-text>

      <v-card-text
        class="subtitle-2"
        style="font-size: 1.3rem !important; text-align: center"
      >
        Llamala.co es un servicio web gratuito que te muestra las tiendas y
        comercios más cercanos a tu ubicación.
      </v-card-text>

      <v-card-text
        class="subtitle-1"
        style="font-size: 1rem !important; text-align: center"
      >
        Te permite <b>LLAMAR GRATIS</b> al comercio de tu barrio. Así puedes
        pedir el domicilio rápidamente, sin gastar minutos, ni marcar números,
        apoyando a las Mipymes y reactivando la economía local.
      </v-card-text>

      <!--
      <v-card-text
        class="caption text-center"
        style="font-size: 0.9rem !important"
      >
        Llamala.co es un servicio web gratuito que te muestra las tiendas y
        comercios más cercanos a tu ubicación, cuando das click, te permite
        LLAMAR GRATIS al comercio de tu barrio, así puedes pedir el domicilio
        rápidamente, sin gastar minutos, ni marcar números, apoyando a las
        Mipymes y reactivando la economía local.
      </v-card-text>
      -->

      <v-card-text class="text-center">
        <v-btn class="elevation-0" color="green" dark @click="$emit('close')">
          Continuar
        </v-btn>

        <br />
        <span class="caption" style="font-size: 0.6rem !important">
          *Aplican condiciones y restricciones
        </span>
      </v-card-text>

      <v-card-text class="d-flex justify-center">
        <img
          src="@/assets/byfontumilogo.png"
          alt=""
          style="width: 100px !important; height: 27.7px !important;"
        />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "AboutDialog",

  props: ["opened"],
};
</script>
